import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

import { AemEnergyLabelRenditions } from "@/components/Product/energyLabel/utils";
import * as ProductUtils from "@/utils/product.utils";

const GPC_EPREL_FEATURE_CODE_SUFFIX = "9.147";
// Legacy fallback
const GPC_ENERGY_FEATURE_CODE_SUFFIX = "4.242";

const ONE_BY_TWO_XS_RENDITION = "250x500";
const ONE_BY_TWO_SM_RENDITION = "350x700";
const ONE_BY_TWO_MD_RENDITION = "480x960";
const ONE_BY_TWO_LG_RENDITION = "600x1200";

const HYBRIS_THUMBNAIL_RENDITION = "110x82";
const HYBRIS_MAIN_RENDITION = "440x330";
const HYBRIS_ZOOM_RENDITION = "800x600";
const HYBRIS_MAX_ZOOM_RENDITION = "1920x1440";

export type EnergyLabelAdapterType = ReturnType<typeof EnergyLabelAdapter>;

const EnergyLabelAdapter = (product: Product<ProductFieldSet.Full>) => {
    const eprelFeatureValue = ProductUtils.getFeatureValue(
        product,
        GPC_EPREL_FEATURE_CODE_SUFFIX
    );

    const energyFeatureValue = ProductUtils.getFeatureValue(
        product,
        GPC_ENERGY_FEATURE_CODE_SUFFIX
    );

    const energyLabelLarge = product.energyLabels.at(0)?.medias.reduce(
        (acc, curr) => {
            if (curr.altText) {
                acc.altText = curr.altText;
            }
            switch (curr.format) {
                case ONE_BY_TWO_XS_RENDITION:
                case HYBRIS_THUMBNAIL_RENDITION:
                    acc.thumbnail = curr.url;
                    break;
                case ONE_BY_TWO_SM_RENDITION:
                case HYBRIS_MAIN_RENDITION:
                    acc.main = curr.url;
                    break;
                case ONE_BY_TWO_MD_RENDITION:
                case HYBRIS_ZOOM_RENDITION:
                    acc.zoom = curr.url;
                    break;
                case ONE_BY_TWO_LG_RENDITION:
                case HYBRIS_MAX_ZOOM_RENDITION:
                    acc.maxZoom = curr.url;
                    break;
            }
            return acc;
        },
        { altText: product.productTitle } as AemEnergyLabelRenditions
    );

    return {
        eprelId: eprelFeatureValue?.formattedValue || null,
        // Legacy fallback for products that don't have the eprel feature but do have the old energy feature
        label: energyLabelLarge || null,
        // Legacy fallback for products that don't have the eprel feature but do have the old energy feature
        labelNested: energyFeatureValue?.imageURL || null,
        altText: energyFeatureValue?.formattedValue || product.productTitle
    };
};

export { EnergyLabelAdapter };
